import { recordAttributionV2Api } from '@repo/sdk';
import { readAttributionFromCookie } from './attribution/read-attribution-from-cookie';

export async function flushAttribution(): Promise<void> {
  const attribution = readAttributionFromCookie();
  if (!attribution) {
    return;
  }
  try {
    await recordAttributionV2Api({
      touchKind: attribution.touchKind === 'web_match' ? 'event' : attribution.touchKind,
      source: attribution.source,
      medium: attribution.medium,
      campaign: attribution.campaign,
      term: attribution.term,
      content: attribution.content,
      referrer: attribution.referrer,
      gclid: attribution.gclid,
      fbclid: attribution.fbclid,
      ttclid: attribution.ttclid,
      msclkid: attribution.msclkid,
      rawUrl: attribution.rawUrl,
      referrerUserId: attribution.referrerUserId ?? null,
      capturedAt: attribution.capturedAt,
    });
  } catch {}
}
